/**
 * Landing — shown when /auth/me returns EMPLOYEE_NOT_MAPPED.
 *
 * The user has logged in via LIFF but is not registered with any
 * tenant yet. Two paths:
 *   1. Owner → /signup (create a new tenant, become OWNER)
 *   2. Employee → /claim (self-register with national ID — the default flow).
 *      /pair (tenant_code + pairing code) kept as a secondary path for owners/HR
 *      invited with a pairing code.
 */
import { Link } from 'react-router-dom';
import { UserPlus, Users, KeyRound } from 'lucide-react';
import { Logo } from '../components/ui/Logo';

export function Landing() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-paper to-gold-wash">
      <div className="card max-w-sm w-full p-6 space-y-5">
        <div className="flex flex-col items-center text-center">
          <Logo size="h-14" wordmark />
          <p className="text-sm text-warm-gray mt-2">PayPilot · ระบบเงินเดือนบน LINE</p>
        </div>

        <p className="text-center text-gray-600">ยินดีต้อนรับ — เริ่มต้นใช้งานเป็น</p>

        <Link to="/signup" className="block">
          <div className="border-2 border-brand-200 rounded-xl p-4 hover:bg-brand-50 transition cursor-pointer">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-brand-gradient text-white flex items-center justify-center shrink-0">
                <UserPlus className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <div className="font-semibold">ฉันเป็น Owner</div>
                <div className="text-xs text-gray-500">สมัครบริษัทใหม่ (ใช้เวลา 30 วินาที)</div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/claim" className="block">
          <div className="border-2 border-gray-200 rounded-xl p-4 hover:bg-gray-50 transition cursor-pointer">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center shrink-0">
                <Users className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <div className="font-semibold">ฉันเป็นพนักงาน</div>
                <div className="text-xs text-gray-500">ลงทะเบียนด้วยเลขบัตรประชาชน</div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/pair" className="block">
          <div className="border-2 border-gray-200 rounded-xl p-4 hover:bg-gray-50 transition cursor-pointer">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center shrink-0">
                <KeyRound className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <div className="font-semibold">มีรหัสจับคู่จากบริษัท</div>
                <div className="text-xs text-gray-500">เชื่อมบัญชีด้วยรหัสบริษัท + รหัสจับคู่</div>
              </div>
            </div>
          </div>
        </Link>

        <p className="text-xs text-gray-400 text-center">
          🔐 ข้อมูลของบริษัทคุณถูกเข้ารหัสด้วยกุญแจเฉพาะของแต่ละบริษัท
        </p>
      </div>
    </div>
  );
}
